import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Spinner } from 'dibs-elements/exports/Spinner';

import styles from './PdpSharedShippingInfoComponent.scss';

type Props = {
    title: ReactNode;
    children?: ReactNode;
};

const PdpSharedShippingInfoLoading: FC<Props> = ({ title, children }) => {
    return (
        <>
            <span className={styles.loadingComponentWrapper}>
                {title}
                <Spinner containerClass={styles.spinnerWrapper} black size="tiny" />{' '}
                <FormattedMessage
                    defaultMessage="Retrieving quote..."
                    id="pdp.PdpSharedShippingInfoLoading.retrievingQuote"
                />
            </span>
            {children}
        </>
    );
};

export default PdpSharedShippingInfoLoading;
